export default {
  女装: "qadın geyimləri",
  男装: "Kişilər üçün",
  手机和小工具: "Mobil telefonlar və qadcetlər",
  居家生活: "ev həyatı",
  电脑及周边设备: "Kompüterlər və periferik avadanlıqlar",
  美容及个人护理: "Gözəllik və şəxsi qulluq",
  家用电器: "məişət texnikası",
  健康与保健: "sağlamlıq və rifah",
  食品和饮料: "Qida və içkilər",
  玩具_儿童和婴儿: "oyuncaqlar, uşaqlar və körpələr",
  童装时尚: "uşaq modası",
  视频游戏: "Video oyunlar",
  运动与户外: "İdman və açıq havada",
  爱好与书籍: "Hobbi və kitablar",
  相机和无人机: "Kameralar və dronlar",
  宠物食品及用品: "Heyvan yemi və ləvazimatları",
  女士包袋: "qadın çantaları",
  男士包袋: "kişi çantaları",
  珠宝及配饰: "Zərgərlik və Aksesuarlar",
  手表: "izləmək",
  女鞋: "qadın ayaqqabıları",
  男装鞋: "kişi ayaqqabıları",
  汽车: "avtomobil",
  我附近的ShopeePay: "Mənə yaxın ShopeePay",
  餐饮_旅行和服务: "Yemək, səyahət və xidmətlər",
  旅行及行李: "Səyahət və baqaj",
  各种各样的: "Müxtəlif növlər",
  我是来买什么的: "Mən nə almaq üçün buradayam?",
  对不起_找不到_相关的商品: "Üzr istəyirik, [{0}] ilə əlaqəli məhsul tapılmadı",
  类别: "kateqoriya",
  产品: "məhsul",
  店铺: "mağaza",
  首页: "ön səhifə",
  限时秒杀: "Məhdud vaxtlı flaş satış",
  博客: "blog",
  所有品牌: "Bütün markalar",
  所有类别: "Bütün kateqoriyalar",
  我的购物车: "alış səbətim",
  发货信息: "çatdırılma məlumatı",
  交货信息: "Çatdırılma məlumatı",
  付款: "Ödəniş",
  确认: "təsdiq edin",
  您的购物车是空的: "Sizin alış-veriş səbətiniz boşdur",
  价格: "qiymət",
  税: "Vergi",
  数量: "kəmiyyət",
  总计: "ümumi",
  移除: "Sil",
  返回商店: "Mağazaya qayıdın",
  继续发货: "Göndərməyə davam edin",
  筛选: "filtr",
  价格范围: "qiymət aralığı",
  排序方式: "sırala",
  最新: "bu günə qədər",
  最旧: "ən qədim",
  价格从低到高: "Qiymət aşağıdan yuxarıya",
  价格从高到低: "Qiymət yüksəkdən aşağıya",
  选择交货类型: "Çatdırılma növünü seçin",
  送货上门: "Çatdırılma",
  继续付款: "Ödəməyə davam edin",
  任何其他信息: "hər hansı digər məlumat",
  或者: "və ya",
  您的钱包余额: "Pul kisəsi balansınız",
  余额不足: "Qeyri-kafi balans",
  支付: "ödəmək",
  我同意: "razıyam",
  条款和条件: "şərtlər və Qaydalar",
  退货政策: "qaytarma siyasəti",
  隐私政策: "Gizlilik Siyasəti",
  概括: "ümumiləşdirmək",
  项目: "layihə",
  全部的: "hamısı",
  小计: "Ara cəmi",
  总运费: "ümumi göndərmə dəyəri",
  有优惠码吗_在这里输入: "Endirim kodu var? bura daxil olun",
  申请: "Müraciət edin",
  编辑: "redaktə et",
  删除: "silin",
  添加新地址: "yeni ünvan əlavə edin",
  继续交货信息: "Çatdırılma məlumatını davam etdirin",
  选择一个地址: "Ünvan seçin",
  购买历史: "Alış tarixi",
  下载: "yükləyin",
  已发送退款请求: "Geri qaytarma sorğusu göndərildi",
  对比: "Müqayisə olunur",
  对话: "dialoq",
  我的钱包: "Mənim çantam",
  工单: "iş sifarişi",
  管理个人资料: "Profili idarə et",
  登出: "Çıxış",
  重置对比列表: "Müqayisə siyahısını sıfırlayın",
  您的对比列表为空: "Müqayisə siyahınız boşdur",
  在您的购物车中: "alış səbətinizdə",
  在您的愿望清单中: "arzu siyahınızda",
  在您的预定列表中: "bron siyahınızda",
  下载您的产品: "Məhsulunuzu yükləyin",
  选项: "Seçimlər",
  什么都没找到: "Heç nə tapılmadı",
  特色产品: "Seçilmiş məhsullar",
  最畅销: "ən yaxşı satıcı",
  前_名: "Ən yaxşı {0}",
  查看更多: "daha çox Gör",
  查看所有类别: "Bütün kateqoriyalara baxın",
  十大品牌: "Ən yaxşı on marka",
  查看所有品牌: "Bütün markalara baxın",
  登录: "Daxil ol",
  手机号码: "telefon nömrəsi",
  密码: "parol",
  密码长度为6到16个字符: "Parolun uzunluğu 6-16 simvoldur",
  验证码: "Yoxlama kodu",
  登录中: "Daxil ol",
  游客登录: "Ziyarətçi girişi",
  注册您的商店: "Mağazanızı qeydiyyatdan keçirin",
  现在申请: "İndi müraciət et",
  成为商家: "Tacir ol",
  现在注册: "İndi qeydiyyatdan keç",
  登录成功: "Uğurla endi",
  通知: "xəbərdar etmək",
  未找到通知: "bildiriş tapılmadı",
  评论: "Şərh",
  估计运输时间: "Təxmini çatdırılma vaxtı",
  天: "səma",
  所售: "satıldı",
  给商家留言: "Satıcıya mesaj buraxın",
  规格: "Spesifikasiya",
  库存: "anbarda",
  总价: "ümumi qiymət",
  添加到购物车: "Səbətə əlavə et",
  立即购买: "İndi alın",
  缺货: "stokda yoxdur",
  添加到愿望清单: "İstək siyahısına əlavə edin",
  加入对比列表: "Müqayisə siyahısına əlavə edin",
  退款: "Geri qaytarma",
  查看条款: "Şərtlərə baxın",
  分享: "paylaş",
  描述: "təsvir etmək",
  相关产品: "Əlaqədar məhsullar",
  没有人问过商家: "Heç kim tacirlərdən soruşmayıb",
  该产品暂无评论: "Bu məhsul üçün hələ heç bir rəy yoxdur",
  客户评论: "müştəri rəyləri",
  访问商店: "mağazaya baş çəkin",
  畅销产品: "Bestsellerlər",
  日期: "Tarix",
  订单编号: "sifariş nömrəsi",
  总额: "birdəfəlik",
  状态: "dövlət",
  愿望清单: "istək siyahısı",
  还没有添加任何东西: "Hələ heç nə əlavə olunmayıb",
  注册: "qeydiyyatdan keçin",
  邀请码: "Dəvət kodu",
  请输入邀请码: "Zəhmət olmasa dəvət kodunu daxil edin",
  用户名: "istifadəçi adı",
  请输入用户名: "istifadəçi adını daxil edin",
  用户名长度为6_14个字符: "İstifadəçi adı uzunluğu 6-14 simvoldur",
  昵称: "Ləqəb",
  请输入手机号码: "Zəhmət olmasa telefon nömrəsini daxil edin",
  手机号码格式错误: "Telefon nömrəsinin səhv formatı",
  密码长度为6_16个字符: "Parolun uzunluğu 6-16 simvoldur",
  确认密码: "Şifrəni təsdiqləyin",
  请输入确认密码: "Təsdiq parolunu daxil edin",
  提款密码: "Çıxarış parolu",
  请输入提款密码: "Zəhmət olmasa, geri çəkilmə parolunu daxil edin",
  提款密码长度为4_16个字符: "Çıxarma parolunun uzunluğu 4-16 simvoldur",
  请输入验证码: "lütfən doğrulama kodunu daxil edin",
  在_s后发送: "{0} saniyədən sonra göndərildi",
  发送验证码: "Doğrulama kodunu göndərin",
  注册即表示您同意我们的条款和条件:
    "Qeydiyyatdan keçməklə siz bizim şərtlərimizlə razılaşırsınız.",
  创建账号: "Hesab yarat",
  验证码发送成功: "Doğrulama kodu uğurla göndərildi",
  确认密码不一致: "Parolun uyğunsuz olduğunu təsdiqləyin",
  提款密码必须为数字: "Çıxarma parolu rəqəmsal olmalıdır",
  注册成功: "qeydiyyat müvəffəqiyyəti",
  购物车: "Alış-veriş kartı",
  账户: "Hesab",
  我的账户: "mənim Hesabım",
  已经有一个账户: "Artıq bir hesabınız var mı",
  新地址: "yeni ünvan",
  编辑地址: "Ünvanı redaktə edin",
  保存: "yadda saxla",
  是否默认: "Defoltdur",
  具体地址: "Xüsusi ünvan",
  请输入具体地址: "Zəhmət olmasa konkret ünvanı daxil edin",
  地区: "sahə",
  请输入地区: "Zəhmət olmasa bölgəni daxil edin",
  城市: "Şəhər",
  请输入城市: "Zəhmət olmasa şəhəri daxil edin",
  省份: "əyalət",
  请输入省份: "Zəhmət olmasa vilayət daxil edin",
  邮政编码: "Poçt kodu",
  请输入邮政编码: "Zəhmət olmasa poçt kodunu daxil edin",
  电话号码: "telefon nömrəsi",
  请输入电话号码: "Zəhmət olmasa telefon nömrənizi daxil edin",
  收货人: "Qəbuledici",
  请输入收货人: "Zəhmət olmasa, alıcını daxil edin",
  保存成功: "Uğurla yadda saxlandı",
  最畅销的商家: "Ən çox satılan tacirlər",
  查看所有的商家: "Bütün bizneslərə baxın",
  支持政策: "Dəstək siyasəti",
  您的电子邮件地址: "Sizin e-poçt ünvanınız",
  订阅: "abunə",
  联系方式: "Əlaqə məlumatı",
  地址: "ünvanı",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, İllinoys, ABŞ",
  快速链接: "Sürətli bağlantılar",
  商家政策: "Satıcı siyasətləri",
  submit: "təqdim",
  提款银行卡: "Pul çıxarma bank kartı",
  我的面板: "mənim panelim",
  提示: "işarə",
  确定登出吗: "Çıxmaq istədiyinizə əminsiniz?",
  确定: "Əlbəttə",
  取消: "Ləğv et",
  项目添加到您的购物车: "Alış-veriş səbətinizə element əlavə edin",
  经常一起购买: "tez-tez birlikdə alırlar",
  返回购物: "Alış-verişə qayıt",
  进行结算: "yoxlamaya davam edin",
  帮助热线: "Yardım xətti",
  查看所有通知: "Bütün bildirişlərə baxın",
  请输入密码: "Zəhmət olmasa parol daxil edin",
  前往充值: "Doldurmağa gedin",
  购物车物品: "Alış-veriş səbətinin əşyaları",
  查看购物车: "alış səbətini yoxlayın",
  钱包余额: "cüzdan balansı",
  充值钱包: "Pul kisəsini doldurun",
  钱包充值_线下_: "Pul kisəsinin doldurulması (oflayn)",
  申请提款: "Geri çəkilmək üçün müraciət edin",
  钱包收支明细: "Pul kisəsinin Gəlir və Xərc Təfərrüatları",
  批准: "təsdiq etmək",
  提现历史记录: "Çıxarma tarixi",
  类型: "növü",
  信息: "məlumat",
  付款方式: "ödəniş üsulu",
  请选择付款方式: "Ödəniş metodu seçin",
  Bill_Type_RECHARGE_BACK: "Arxa uçun doldurulması",
  Bill_Type_RECHARGE_ONLINE: "Onlayn doldurma",
  Bill_Type_RECHARGE_REGISTER: "Pulsuz qeydiyyatdan keçin",
  Bill_Type_RECHARGE_JACKPOT: "Doldurma bonusu",
  Bill_Type_RECHARGE_PRESENT: "Mükafatları doldurun",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Komissiya transferi",
  Bill_Type_RECHARGE_TG_COMMISSION: "Təşviq komissiyasını doldurun",
  Bill_Type_REGISTER_TG_COMMISSION: "Qeydiyyatın təşviqi komissiyası",
  Bill_Type_WITHDRAW: "geri çəkilmək",
  Bill_Type_WITHDRAW_REJECT: "Çıxarma rədd edildi",
  Bill_Type_DEDUCT_HANDLE: "Əllə çıxma",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Doldurma korreksiyası",
  Bill_Type_MINING_PROFIT: "Mədən gəliri",
  Bill_Type_MINING_PROFIT_COMMISSION: "Mədən gəlirlərinin təşviqi komissiyası",
  Bill_Type_VIP_UPGRADE: "VIP-i təkmilləşdirin",
  Bill_Type_FINANCE_BUY: "Maliyyə məhsulları alın",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Maliyyə balansının qaytarılması",
  Bill_Type_FINANCE_FEE: "Maliyyə idarəetmə haqları",
  Bill_Type_FINANCE_PROFIT: "Maliyyə idarəçiliyindən gəlir",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Maliyyə məhsullarının alınması üçün komissiya",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Maliyyə məhsulundan gəlir komissiyası",
  Bill_Type_WHEEL_DRAW: "Böyük təkər lotereyası",
  Bill_Type_BUY: "mal almaq",
  Bill_Type_PAY_SHOP: "Göndərmə üçün ödəyin",
  Bill_Type_BUY_COMMISSION: "Alınan əşyalara görə komissiya",
  Bill_Type_DEPOSIT: "Depozit ödə",
  Bill_Type_STORE_BUY: "mal almaq",
  Bill_Type_STORE_BUY_REFUND: "Satın alınan məhsulun geri qaytarılması",
  Bill_Type: "Hesab dəyişikliyi növü",
  Before_Money: "əvvəlki məbləğ",
  Deal_Money: "Hesab dəyişmə məbləği",
  After_Money: "Sonrakı məbləğ",
  Bill_Time: "Hesab dəyişmə vaxtı",
  No_More_Data: "artıq məlumat yoxdur",
  Apply_Money: "Ərizə məbləği",
  Apply_Time: "tətbiq vaxtı",
  Withdraw_Info: "Xidmət haqqı: {fee}, gəliş: {money}",
  提款订单状态_CHECKING: "Baxış gözlənilir",
  提款订单状态_TRANSFERRING: "Transfer edilir",
  提款订单状态_PASS: "təsdiqləndi",
  提款订单状态_REJECT: "İşdən çıxarıldı",
  暂无可用充值方式: "Hələ heç bir doldurma üsulu mövcud deyil",
  钱包收款码: "Pul kisəsi ödəniş kodu",
  钱包地址: "cüzdan ünvanı",
  金额限制: "Məbləğ limiti",
  复制: "surəti",
  付款凭证: "ödəniş çeki",
  收款银行: "Benefisiar Bank",
  收款人: "Alıcı",
  收款账号: "Ödəniş hesab nömrəsi",
  付款银行: "ödəniş bankı",
  付款人: "Ödəyici",
  付款账号: "Ödəniş hesabı",
  请输入付款银行: "Zəhmət olmasa ödəniş bankını daxil edin",
  请输入付款人: "Zəhmət olmasa ödəyəni daxil edin",
  请输入付款账号: "Ödəniş hesab nömrəsini daxil edin",
  请上传付款凭证: "Zəhmət olmasa ödəniş çekini yükləyin",
  充值金额: "Doldurma məbləği",
  请输入充值金额: "Zəhmət olmasa doldurma məbləğini daxil edin",
  submitting: "təqdim olunur...",
  Confirm: "təqdim",
  Commit_Success: "Uğurla təqdim edildi",
  balanceType_BALANCE: "balans",
  balanceType_COMMISSION: "komissiya",
  Balance: "Hesab balansı",
  Wash_Money: "mozaika əlavə edin",
  请选择银行账户: "Zəhmət olmasa bank hesabı seçin",
  卡号类型: "Kart nömrəsi növü",
  提现金额: "Çıxarma məbləği",
  提款金额: "Çıxarma məbləği",
  不能为空: "Boş ola bilməz",
  金额不正确: "Məbləğ səhvdir",
  please_input_withdraw_password:
    "Zəhmət olmasa, geri çəkilmə parolunu daxil edin",
  withdraw_password_format_error:
    "Çıxarma parolu 4-16 simvoldan ibarət olmalıdır",
  Fee: "idarə haqqı",
  实际到账: "Faktiki gəliş",
  交易币种: "Əməliyyat valyutası",
  原始密码: "orijinal parol",
  confirm_password_error: "İki dəfə daxil edilən parol səhvdir",
  save_success: "Uğurla yadda saxlandı",
  please_input: "zəhmət olmasa daxil edin",
  old_password: "köhnə Şifrə",
  new_password: "yeni şifrə",
  please_input_confirm_password: "Şifrəni yenidən təsdiqləyin",
  没有找到符合条件的商品: "Uyğun məhsul tapılmadı",
  Search: "axtarış",
  全部: "hamısı",
  EnumGoodsOrderState_USER_PAY: "Çatdırılma gözlənilir",
  EnumGoodsOrderState_SHOP_PAY: "Çatdırılır",
  EnumGoodsOrderState_SUCCESS: "Bitir",
  EnumGoodsOrderState_CANCEL: "Ləğv edildi",
  EnumGoodsOrderState_REFUND_SUCCESS: "geri qaytarıldı",
  订单号: "sifariş nömrəsi",
  用户名称: "istifadəçi adı",
  收益: "gəlir",
  支付时间: "Ödəniş vaxtı",
  配送时间: "Çatdırılma vaxtı",
  完成时间: "Tam vaxt",
  发货: "gəmi",
  全选: "hamısını seç",
  物品已添加到愿望清单: "Element istək siyahısına əlavə edildi",
  物品已添加到比较列表: "Element müqayisə siyahısına əlavə edildi",
  购买成功提示: "Təbrik edirik, alışınız uğurlu oldu",
  订单列表: "Sifariş siyahısı",
  商品名: "Məhsulun adı",
  图片: "şəkil",
  没有品牌: "marka yoxdur",
  基本信息: "Əsas məlumat",
  Account_Name: "Hesabın açılması adı",
  Bank_Account: "Bank hesabı",
  Bank_Phone: "Mobil telefon nömrəsini rezerv edin",
  IFSC: "IFSC hesabı",
  UPI: "UPI hesabı",
  PIX: "PIX hesabı",
  CPF: "CPF hesabı",
  GCASH: "GCASH hesabı",
  POWWI: "POWWI hesabı",
  身份证号: "ID nömrəsi",
  Edit: "Yenidən nəzərdən keçirin",
  Delete: "silin",
  Add: "Yeni",
  Forget_Withdraw_Password: "Çıxarış parolunu unutmusunuz",
  Bank_Card_Info: "Bank kartı məlumatı",
  收款人地址: "Alıcı ünvanı",
  SWIFT: "CƏLD",
  Bank_Branch: "Filialı adı",
  分行代码: "filialın kodu",
  银行地址: "Bank ünvanı",
  Email: "E-poçt",
  银行卡长度必须超过: "Bank kartının uzunluğu {length}-dən çox olmalıdır",
  银行卡格式不正确: "Bank kartının formatı yanlışdır",
  Do_you_confirm_delete: "Silinmə təsdiq edilsin?",
  Please_Login_First: "zəhmət olmasa əvvəlcə daxil olun",
  Bank_Name: "Bank adı",
  Please_add_bank_first:
    "Siz hələ bank kartınızı bağlamamısınız, zəhmət olmasa əvvəlcə onu əlavə edin",
  withdrawType: "Çıxarma növü",
  withdraw_money_limit:
    "Çıxarma məbləği 0-dan böyük və {balance}-dən az və ya bərabər olmalıdır",
  withdraw_times_limit:
    "Siz bu gün {todayWithdrawNum} dəfə geri çəkmisiniz və {limitTimes} dəfədən sonra {withdrawFee}% əməliyyat haqqı tutulacaq. Geri çəkiləcəyinizə əminsiniz?",
  Copy_Success: "Uğurla kopyalandı",
  商店首页: "Mağazanın ana səhifəsi",
  所有产品: "Bütün məhsullar",
  新到货产品: "Yeni gələn məhsullar",
  所有商家: "Bütün tacirlər",
  请上传: "Zəhmət olmasa yükləyin",
  请输入: "zəhmət olmasa daxil edin",
  忘记密码: "parolu unut",
  记得我: "məni xatırla",
  共_件: "Cəmi {0} element",
  取消订单: "sifarişi ləğv et",
  申请退款: "Pulun geri qaytarılmasını tələb edin",
  未知商家: "Naməlum tacir",
  到账: "Qəbz",
  提款订单状态: "Sifarişin çıxarılması vəziyyəti",
  前_名类别: "Ən yaxşı {0} kateqoriyalar",
  取消订单原因_不想要了: "Daha istəmə",
  取消订单原因_商品错选_多选: "Yanlış məhsul seçimi/birdən çox seçim",
  取消订单原因_商品无货: "Məhsul stokda yoxdur",
  取消订单原因_地址信息填写错误: "Ünvan məlumatları səhv doldurulmuşdur",
  取消订单原因_商品降价: "Məhsulun qiymətində azalma",
  取消订单原因_价格高于其他平台: "Qiyməti digər platformalardan bahadır",
  取消订单原因_没用_少用_错用优惠:
    "Endirimlərdən heç bir faydası/az istifadəsi/sui-istifadəsi yoxdur",
  退款原因_拍错_多拍_不喜欢: "Səhv atış / əlavə atış / xoşuma gəlmir",
  退款原因_商品成分描述不符: "Məhsulun tərkib hissəsi təsviri uyğun gəlmir",
  退款原因_与商家协商一致退款: "Satıcı ilə razılaşdırıldığı kimi geri qaytarın",
  退款原因_生产日期_保质期与商品描述不符:
    "İstehsal tarixi/rəf ömrü məhsulun təsvirinə uyğun gəlmir",
  退款原因_图片_产地_批号_规格等描述不符:
    "Şəkillər/mənşənin mənşəyi/partiya nömrəsi/spesifikasiyalar və digər təsvirlər uyğun gəlmir",
  退款原因_质量问题: "Keyfiyyət məsələləri",
  退款原因_商品变质_发霉_有异物: "Məhsul xarab olub/kiflənib/yad cisim var",
  退款原因_少件_含缺少配件_: "Bir neçə ədəd (əskik aksesuarlar daxil olmaqla)",
  退款原因_收到商品时有破损_污渍_变形:
    "Alınan zaman əşya zədələnmiş/ləklənmiş/deformasiya edilmişdir.",
  退款原因_假冒品牌: "Saxta brendlər",
  退款原因_发票问题: "Faktura problemləri",
  退款原因_商家发错货: "Tacir yanlış mal göndərdi",
  退款原因_预约不到_商家不给退换:
    "Görüş təyin etmək mümkün deyil/tacir geri qaytarılmayacaq və ya dəyişdirilməyəcək",
  退款失败: "Pulun qaytarılması alınmadı",
  退款处理中: "Geri qaytarma davam edir",
  默认: "default",
  产品查询: "Məhsul Axtarışı",
  商店LOGO: "Mağaza LOGO",
  推广码: "Promosyon kodu",
  查看所有: "hamısına baxmaq",
  确认收货成功: "Malların qəbulunu uğurla təsdiqləyin",
  物流公司: "Logistika şirkəti",
  物流单号: "göndəriş nömrəsi",
  发货时间: "Çatdırılma vaxtı",
  请先选择商品规格: "Zəhmət olmasa əvvəlcə məhsulun spesifikasiyalarını seçin",
  个人信息: "Şəxsi məlumat",
  您的用户名: "istifadəçi adınız",
  你的名字: "sənin adın",
  登录名: "istifadəçi adı",
  你的邮件: "e-poçtunuz",
  你的密码: "parolunuz",
  重复输入密码: "Parolu təkrarlayın",
  店铺名称: "Mağaza Adı",
  证书类型: "Sertifikat növü",
  身份证: "Şəxsiyyət vəsiqəsi",
  护照: "pasport",
  驾驶执照: "sürücünün lisenziyası",
  社会保障卡: "Sosial sığorta kartı",
  证书正面: "Sertifikat cəbhəsi",
  证书反面: "sertifikatın arxa tərəfi",
  确认收货: "malların qəbulunu təsdiqləyin",
  请选择取消订单的原因必选:
    "Sifarişin ləğv edilməsinin səbəbini seçin (tələb olunur):",
  请选择申请退款的原因必选:
    "Zəhmət olmasa, geri qaytarma tələbinin səbəbini seçin (tələb olunur):",
  留言: "mesaj",
  请输入留言: "Zəhmət olmasa mesaj daxil edin",
  没有帐户: "Hesab yoxdur",
  钱包充值: "Pul kisəsinin doldurulması",
  输入您的文字: "Mətninizi daxil edin",
  商家登录: "Satıcı girişi",
  有关此产品的任何查询: "Bu məhsul haqqında hər hansı bir sorğu",
  产品名称: "məhsul adı",
  你的问题: "sizin probleminiz",
  白银店铺: "gümüş dükanı",
  铂金店铺: "platin mağazası",
  钻石店铺: "almaz mağazası",
  照片: "Şəkil",
  已退货: "Qayıtdı",
  邮寄状态: "Poçt statusu",
  订单摘要: "Sifariş Xülasə",
  收件地址: "Alıcı ünvanı",
  订购日期: "Sifariş tarixi",
  订单状态: "Sifariş Vəziyyəti",
  总订单金额: "Sifarişin ümumi məbləği",
  邮寄方式: "Poçt üsulu",
  附加信息: "əlavə informasiya",
  订单详细信息: "Sifariş detalları",
  交货类型: "Çatdırılma növü",
  进行评论: "Şərh bildirin",
  已评论: "Şərh edildi",
  订单金额: "sifariş məbləği",
  优惠券: "kupon",
  统一运费: "Düz çatdırılma haqqı",
  送货地址: "Çatdırılma ünvanı",
  评分: "xal",
  你的意见: "fikrin",
  匿名: "anonim",
  现金: "nağd pul",
  详情: "Təfərrüatlar",
  收货地址: "Çatdırılma ünvanı",
  暂时没有对话: "Hələ söhbət yoxdur",
  你: "Sən",
  输入您的回复: "Cavabınızı daxil edin",
  删除成功: "uğurla silindi",
  品牌: "brend",
  已缴纳的保证金: "Təhlükəsizlik depoziti ödənildi",
  黄金店铺: "qızıl mağazası",
  没有更多数据: "artıq məlumat yoxdur",
  站内信: "Sayt mesajı",
  系统通知: "sistem bildirişi",
  邮箱: "Poçt",
  手机号: "Telefon nömrəsi",
  你的手机号: "telefon nömrəniz",
  营业执照: "biznes lisenziyası",
  你的邮箱: "poçt qutunuz",
  搜索结果: "axtarış nəticələri",
  系统公告: "sistem bildirişi",
  客服: "müştəri xidməti",
  消息已撤回: "Mesaj geri götürüldü",
  物流详情: "Logistika təfərrüatları",
  充值: "Yuxarı",
  提现: "geri çəkilmək",
  信用分: "kredit hesabı",
  余额: "balans",
  佣金: "komissiya",
  继续购物: "alış-verişə davam edin",
  订单结算: "Sifarişlə hesablaşma",
  加入对比: "Müqayisə üçün əlavə edin",
  佣金余额: "Komissiya balansı",
  刷新: "təzələmək",
  刷新成功: "Yeniləmə uğurlu oldu",
  官网: "Rəsmi sayt",
  税号: "Vergi ID nömrəsi",
  订单: "Sifariş verin",
  合计: "ümumi",
  系统安全: "Sistem təhlükəsizliyi",
  Recharge_Money_Limit: "Doldurma məbləği {min} və {max} arasında olmalıdır",
  限时优惠: "Məhdud vaxt təklifi",
  高价回收: "Yüksək qiymətli təkrar emal",
  姓名: "ad",
  商品订单号: "Məhsulun sifariş nömrəsi",
  商品在线回收: "Məhsulun onlayn təkrar emalı",
  提交: "təqdim edin",
  回收记录: "Təkrar emal qeydləri",
  回收状态: "Təkrar emal vəziyyəti",
  回收价格: "təkrar emal qiyməti",
  纳税码: "vergi kodu",
  买家登录: "Daxil ol",
  买家注册: "qeydiyyatdan keçin",
  language: "阿塞拜疆",
  助力提示:
    "Ticarətçilərin platformanın mağazalarına məruz qalmasına kömək edə bilər və günlərin məcmu sayı nə qədər yüksək olsa, məruz qalma daha yüksəkdir.",
  已累计助力: "Cumulat",
  今日已助力: "Bu gün kömək etdi",
  立即助力: "Dərhal kömək etmək",
  商家助力: "Tacir köməyi",
  证件号码: "İd nömrəsi",
  证书号码: "Sertifikat nömrəsi"
};
